<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title class="previewTitle">{{ title }}</h1>
<div mat-dialog-content>
  <app-drilldown-table-chart
    [form]="form"
    [index]="index"
    [userOptions]="userOptions"
  ></app-drilldown-table-chart>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="button_small cancel">Close</button>
</div>
